import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { SET_IMPORTANT_DATA, SET_IMPORTANT_DATA_MSB } from '@/graphql/important';
import { bizmatesWordbookApi } from '@/utils/bizmatesApi';
import logger from '@/modules/Logger';
import qs from 'qs';

export const SetImportantDataService = {
  msb: async (params) => {
    logger.debug(`[Set as Important] Set as important from MSB GraphQL endpoint`, {
      operation: 'vocabulary:mark-important'
    });
    const client = myStageApolloProvider.defaultClient;
    await client.mutate({
      mutation: SET_IMPORTANT_DATA_MSB,
      variables: {
        id: params.id,
        is_important: params.important,
      }
    });
  },
  
  mbti: async (params) => {
    logger.debug(`[Set as Important] Set as important from MBTI GraphQL endpoint`, {
      operation: 'vocabulary:mark-important'
    });
    const client = apolloProvider.defaultClient;
    await client.mutate({
      mutation: SET_IMPORTANT_DATA,
      fetchPolicy: 'no-cache',
      variables: {
        id: params.id,
        is_important: params.important,
      }
    });
  },
  
  legacy: async (params) => {
    logger.debug(`[Set as Important] Set as important using legacy REST API`, {
      operation: 'vocabulary:mark-important'
    });
    await bizmatesWordbookApi.post('word/important', qs.stringify(params), err => err);
  }
};
